<template>
  <div class="view agent-new-password">

    <h1>{{ $t('agent.set-password.label') }}</h1>

    <p class="instruction">{{ $t('agent.set-password.instruction') }}</p>

    <form-input type="password" :label="$t('general.label.password')" icon="password"/>
    <form-input type="password" :label="$t('general.label.confirm-password')" icon="password"/>

    <button class="button-set-password" type="submit">{{ $t('agent.set-password.label') }}</button>

    <!-- *This link is just showing the next page. Please remove -->
    <router-link class="forgot-password" :to="{name: 'agent'}">(Login and go to Agent Home ->)</router-link>

  </div>
</template>

<script>
import FormInput from '@/components/FormInput.vue';

export default {
  name: 'AgentSetPassword',

  data() {
    return {
    }
  },

  components: {
    FormInput
  }
}
</script>

<style lang="scss">
.view.agent-new-password {
  @include small-page-layout;

  .instruction {
    margin-bottom: 25px;
  }

  .component.form-input {
    @include form-layout-wide;
  }

  .password .icon { @include font-awesome($fa-var-lock-alt, light); }

  .button-set-password {
    @include button($colorCTA, #fff);
    width: 100%;
  }
}
</style>
